import AppDispatcher from '../../core/AppDispatcher'
import { appActions } from '../AppActions'
import AccountTitleRepository from '../../infra/AccountTitleRepository'
import AccountTitleDetailEvent from '../../event/AccountTitleDetailEvent'

const onRequestCreateDetail = async detail => {
  const response = await AccountTitleRepository.requestCreateByDetail(detail).catch(e => e)
  if (response instanceof Error) {
    appActions.showAlert(response, '登録できませんでした')
    return false
  }

  appActions.snackbar('登録しました', 'success', true)
  AppDispatcher.dispatchWithType(AccountTitleDetailEvent.fetchOne, { detail: response })
  return true
}

export default onRequestCreateDetail
